module.exports = __webpack_public_path__ + "static/media/hourglass.a323b319.png";